import styled from 'styled-components';

import { ClickableContainer } from 'components/clickable-container';
import { ModalHeading } from 'components/modal';

export const ModalContentWrapper = styled.div`
  display: flex;
  height: 100%;
  position: relative;
`;

export const PreOrderTimeModalBody = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  position: relative;
  height: calc(100% - 14vh);
  width: 100%;
  padding: 0.5rem 1.5rem;

  ${Styles.mobile} {
    height: calc(100% - 8rem);
  }
`;

export const HeaderText = styled(ModalHeading)`
  text-align: start;
  margin: 0 auto;
  font-size: 1.85rem;
  max-width: 100%;
  white-space: normal;
  margin-block-start: -0.5rem;
  margin-block-end: 1rem;

  ${Styles.mobile} {
    font-size: 1.6rem;
    margin-block-end: 0.5rem;
  }
`;

export const TimeSlotList = styled.div`
  display: flex;
  padding: 0.5rem 0;
  flex-direction: column;
  align-items: end;
  inset-block-end: 0;
  ${Styles.mobile} {
    height: calc(100vh - 7.5rem);
  }
`;

export const TimeslotItem = styled(ClickableContainer)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0.8rem 0;
  &:not(:last-child) {
    border-block-end: 1px solid rgba(0, 0, 0, 0.1);
  }
`;

export const RadioButtonContainer = styled.div`
  margin-block-end: -0.5rem;
`;

export const ButtonContainer = styled.div`
  height: 12vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 1rem;
  position: fixed;
  inset-block-end: 0;
  inset-inline-end: 0;
  inset-inline-start: 0;
  margin-block-end: auto;
  background-color: ${Styles.color.dialogBackground};

  ${Styles.mobile} {
    border-block-start: 1px solid rgba(0, 0, 0, 0.1);
    height: 8rem;
  }
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
